import { baseResourceOptions } from './utils';
import createCollectionResource from 'src/actions/shared/createResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';
import { ExternalAction } from 'src/models/Sidekick/SidekickModuleSpec';

const sidekickExternalActionsResource = createCollectionResource<ExternalAction>({
  name: 'sidekickExternalActions',
  endpoint: 'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/flows-next/external-actions',
  type: ExternalAction,
  observerCreator: emptyObserverCreator,
  options: {
    ...baseResourceOptions,
    transformDataBeforeStore: <ExternalAction>(data: unknown): ExternalAction[] => {
      const rawData = data as { data: { externalActions: ExternalAction[] } };
      return rawData.data.externalActions;
    },
  },
});

export default sidekickExternalActionsResource;
